import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import { DiscrepancyLog } from '../../../types/discrepancy-log';
import { updateDiscrepancyLog } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateDiscrepancyLogReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; xmlId: string; newValue: string },
): Readonly<FormState> {
    const oldDiscrepancyLog = state.participantCopies[state.selectedParticipantCopyId].functionalElements[
        props.id
    ] as DiscrepancyLog;

    if (oldDiscrepancyLog.value === props.newValue) {
        return state;
    }

    const newDiscrepancyLog: { [key: string]: Readonly<DiscrepancyLog> } = {};
    newDiscrepancyLog[props.id] = { ...oldDiscrepancyLog, value: props.newValue };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newDiscrepancyLog,
    });
}

export const discrepancyLogReducer = [
    on<FormState, Array<typeof updateDiscrepancyLog>>(updateDiscrepancyLog, updateDiscrepancyLogReducer),
];
